// pages/mind-mesch/Terms.js

import React from 'react';

const Terms = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Terms of Service</h1>
      <p>By using Mind Mesch, you agree to the following terms:</p>

      <ul>
        <li>You will not use the platform for any illegal activities.</li>
        <li>API usage must comply with your assigned partner key and rate limits.</li>
        <li>You retain ownership of your data but grant us permission to process it securely.</li>
        <li>We may update these terms as needed; you will be notified of material changes.</li>
      </ul>

      <p>If you have any questions, contact <a href="mailto:legal@mind-mesch.com">legal@mind-mesch.com</a>.</p>
    </div>
  );
};

export default Terms;
